export function formatAsCurrency(value: number | null, places: number = 2, useCommas: boolean = true, defaultValue: string = 'N/A', minimumPlaces: number | null = null): string {
    if (value === null)
        return defaultValue;

    const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: minimumPlaces != null ? minimumPlaces : places, maximumFractionDigits: places, useGrouping: useCommas });
    return `${value < 0 ? '-' : ''}$${formatter.format(Math.abs(value))}`;
};